import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";
import NavBar from "./NavBar";
import ProductImageSlideshow from "./ProductImageSlideshow";

function CollectionPage() {
  const { collectionName } = useParams();
  const { state } = useLocation();
  const [products, setProducts] = useState([]);
  const [sortOption, setSortOption] = useState("newest");
  const db = getFirestore();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const productsSnapshot = await getDocs(collection(db, collectionName));
        const allDocs = productsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Pull productFilter doc
        const filterDoc = allDocs.find((item) => item.id === "productFilter");
        if (filterDoc?.type) {
          setSortOption(filterDoc.type);
        }

        setProducts(allDocs);
      } catch (error) {
        console.error("Error fetching products: ", error);
      }
    };

    fetchProducts();
  }, [db, collectionName]);

  const handleGoBack = () => {
    window.history.back();
  };

  const filteredData = useMemo(() => {
    return products.filter(
      (item) => item.id !== "heading" && item.id !== "productFilter"
    );
  }, [products]);

  const sortedData = useMemo(() => {
    let sorted = [...filteredData];

    if (sortOption === "lowToHigh" || sortOption === "price-low") {
      sorted.sort(
        (a, b) => parseFloat(a.productPrice) - parseFloat(b.productPrice)
      );
    } else if (sortOption === "highToLow" || sortOption === "price-high") {
      sorted.sort(
        (a, b) => parseFloat(b.productPrice) - parseFloat(a.productPrice)
      );
    } else if (sortOption === "newest") {
      sorted.sort(
        (a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0)
      );
    } else if (sortOption === "oldest") {
      sorted.sort(
        (a, b) => (a.createdAt?.seconds || 0) - (b.createdAt?.seconds || 0)
      );
    }

    return sorted;
  }, [filteredData, sortOption]);

  return (
    <>
      <NavBar />

      <div className="goBackBtn ms-5 mt-2" role="button" onClick={handleGoBack}>
        <i className="bi bi-arrow-left-short fs-3">Go Back</i>
      </div>

      <div className="container mt-3 text-center">
        <h1>{state?.heading || collectionName.replace("_", " ")}</h1>
        <div className="form-group text-start mt-4">
          <label htmlFor="sortOptions" className="form-label ms-2">
            Sort by:
          </label>
          <select
            id="sortOptions"
            className="form-select form-control bg-dark text-light border-0"
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
          >
            <option value="newest">Newest</option>
            <option value="oldest">Oldest</option>
            <option value="lowToHigh">Price, Low To High</option>
            <option value="highToLow">Price, High To Low</option>
          </select>
        </div>
        <p className="text-light text-end">{sortedData.length} Products</p>
        <div className="row">
          {sortedData.map((product) => (
            <div className="col-6 col-md-4 col-lg-3 mb-4" key={product.id}>
              <div className="card border-0 p-2">
                <Link
                  to={`/product/${collectionName}/${product.id}`}
                  state={{ product, collectionName }}
                  className="link"
                >
                  <ProductImageSlideshow
                    item={product}
                    alt={product.productTitle}
                  />
                  <div className="card-body p-2">
                    <h5 className="card-title text-start">
                      {product.productTitle}
                    </h5>
                    <p className="card-text text-start">
                      Rs {product.productPrice} PKR
                      {product.oldPrice && (
                        <div className="card-text text-start old_price">
                          Rs {product.oldPrice} PKR
                        </div>
                      )}
                    </p>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default CollectionPage;
